import React from 'react';
import { WatchlistEvaluation } from '../services/watchlistEnforcement';

/**
 * ComplianceBanner
 *
 * Fixed-position banner that reflects a post-login compliance evaluation.
 * Two visual tones:
 *
 *   - BLOCKED → red; forces a "Log out" call-to-action.
 *   - WARN    → amber; advisory only.
 *
 * The component is purely presentational — callers wire it through
 * `evaluateWalletAtLogin(...)` and control dismissal policy.  A BLOCKED
 * banner cannot be dismissed; the caller must separately log the user out
 * of the smart account.
 */

export interface ComplianceBannerProps {
  evaluation: WatchlistEvaluation | null;
  wallet?: string;
  onLogout?: () => void;
  onDismiss?: () => void;
}

const ComplianceBanner: React.FC<ComplianceBannerProps> = ({ evaluation, wallet, onLogout, onDismiss }) => {
  if (!evaluation || evaluation.decision === 'CLEAR') return null;
  const blocked = evaluation.decision === 'BLOCKED';
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000,
      padding: '10px 16px', fontSize: 13,
      background: blocked ? '#991b1b' : '#92400e', color: '#fff',
      display: 'flex', alignItems: 'center', gap: 12,
    }}>
      <span style={{ fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>
        {blocked ? 'Access denied' : 'Warning'}
      </span>
      <span style={{ flex: 1 }}>
        {evaluation.humanReason}
        {wallet && <span style={{ opacity: 0.8, marginLeft: 8 }}>({wallet.slice(0, 10)}…)</span>}
      </span>
      {blocked ? (
        <button onClick={onLogout} style={{
          padding: '6px 10px', background: '#fff', color: '#991b1b', border: 'none',
          borderRadius: 6, cursor: 'pointer', fontWeight: 600,
        }}>Log out</button>
      ) : (
        <button onClick={onDismiss} style={{
          padding: '4px 8px', background: 'transparent', color: '#fff',
          border: '1px solid #fff8', borderRadius: 6, cursor: 'pointer',
        }}>Acknowledge</button>
      )}
    </div>
  );
};

export default ComplianceBanner;
